
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import QuickViewModal from '../Modal/QuickViewModal';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import LoginModal from '../Modal/LoginModal';
import ProductModal from '../Modal/ProductModal';
import ProductQuickViewModal from '../Modal/ViewModal';

const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};

const TodaysPick = () => {
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [showQuickView, setShowQuickView] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [mobilePage, setMobilePage] = useState(0);
  const [products, setProducts] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();

  // Mobile swipe handlers
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);

  
    const fetchProducts = async () => {
      try {
        const token = getAuthToken();
        let axiosConfig = {};

        if (token) {
          axiosConfig = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
        }

        const res = await axios.get(
          "https://vantara.datacubeglobal.com/api/random_products",
          axiosConfig
        );

        if (res.data.status === "success") {
          setProducts(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };
useEffect(() => {
    fetchProducts();
  }, []);

  const latestProducts = [...products]
    .sort((a, b) => b.product_id - a.product_id)
    .slice(0, 4);

  // Mobile swipe handlers
  const handleTouchStart = (e) => {
    setTouchStartX(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEndX(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStartX || !touchEndX) return;
    const distance = touchStartX - touchEndX;
    const threshold = 50;
    if (distance > threshold) {
      handleNext();
    } else if (distance < -threshold) {
      handlePrev();
    }
    setTouchStartX(0);
    setTouchEndX(0);
  };

  const handleNext = () => {
    const totalPages = Math.ceil(products.length / 2);
    setMobilePage(prev => (prev + 1) % totalPages);
  };

  const handlePrev = () => {
    const totalPages = Math.ceil(products.length / 2);
    setMobilePage(prev => (prev - 1 + totalPages) % totalPages);
  };

  const getImageUrl = (product) => {
    if (!product.primary_image) return '';
    const url = `https://vantara.datacubeglobal.com/storage/${product.primary_image.replace(/^\//, '')}`;
    return url;
  };

  const toggleWishlist = async (product) => {
    const token = getAuthToken();

    if (!token) {
      setShowLoginModal(true);
      return;
    }

    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/wishlist",
        { product_id: product.product_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.message === "Unauthenticated.") {
        setShowLoginModal(true);
        return;
      }

      if (res.data.status === true) {
        if (res.data.message === "Removed") {
          setWishlist(wishlist.filter((id) => id !== product.product_id));
          Swal.fire({
            toast: true,
            icon: "info",
            title: "Removed from Wishlist",
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        } else {
          setWishlist([...wishlist, product.product_id]);
          Swal.fire({
            toast: true,
            icon: "success",
            title: "Added to Wishlist",
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        }
           fetchProducts();
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setShowLoginModal(true);
      } else {
        console.error("Error updating wishlist:", error);
        Swal.fire({
          toast: true,
          icon: "error",
          title: "Something went wrong!",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    }
  };

  const handleQuickAdd = (productId) => {
    const token = getAuthToken();

    if (!token) {
      setShowLoginModal(true);
      return;
    }
    const apiProduct = products.find(p => p.product_id === productId);
    if (apiProduct) {
      const formattedProduct = {
        id: apiProduct.product_id,
        name: apiProduct.product_name,
        price: parseFloat(apiProduct.special_price) || parseFloat(apiProduct.mrp),
        originalPrice: parseFloat(apiProduct.mrp),
        image: getImageUrl(apiProduct),
      };

      setSelectedProduct(formattedProduct);
      setShowQuickView(true);
    }
  };

  // Body overflow control for modals
  useEffect(() => {
    if (showQuickView) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [showQuickView]);

  return (
    <div className="container-fluid px-3 px-md-5 my-5">
      <style>{`
        @media (max-width: 767px) {
          .position-absolute.top-50.start-0,
          .position-absolute.top-50.end-0 {
            display: none !important;
          }
        }
      `}</style>

      <div className="text-center mb-4">
        <h2  className="text-center mb-4 fw-bold">Today's Top Picks</h2>
        <p style={{ color: "#555", fontSize: "1.2rem" }}>Fresh styles just in! Elevate your look.</p>
      </div>

      {/* Desktop View - Always visible, no observer needed */}
      <div className="d-none d-md-block">
        {latestProducts.length === 0 ? (
          <div className="text-center py-5">
            <p>Loading today's picks...</p>
          </div>
        ) : (
          <div className="row">
            {latestProducts.map((product, index) => (
              <div
                key={product.product_id}
                className="col-md-6 col-lg-3 mb-4"
                style={{
                  opacity: 1,
                  transform: 'translateY(0)',
                  transition: `all 0.8s ease ${index * 0.2}s`
                }}
              >
                <div
                  className="card border-0 h-100"
                  onMouseEnter={() => setHoveredProduct(product.product_id)}
                  onMouseLeave={() => setHoveredProduct(null)}
                >
                  <div className="position-relative overflow-hidden"  style={{
    height: "350px", // uniform image height (adjust as needed)
    borderRadius: "12px",
    backgroundColor: "#f8f8f8", // fallback color while loading
  }}>
                    <button
                      className="position-absolute top-0 end-0 d-flex justify-content-center align-items-center"
                      onClick={() => toggleWishlist(product)}
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        backgroundColor: '#fff',
                        border: 'none',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        zIndex: 50,
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease',
                        margin: '8px',
                        padding: 0,
                      }}
                      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
                      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    >
                      {product.is_wishlisted ? (
                        <FaHeart style={{ color: '#000' }} size={18} />
                      ) : (
                        <FaRegHeart style={{ color: '#000' }} size={18} />
                      )}
                    </button>

                    {/* {product.special_price && product.mrp && parseFloat(product.special_price) < parseFloat(product.mrp) && (
                      <span
                        className="badge bg-danger position-absolute top-0 start-0 m-2"
                        style={{ zIndex: 50 }}
                      >
                        {`-${Math.round(100 - (parseFloat(product.special_price) / parseFloat(product.mrp)) * 100)}%`}
                      </span>
                    )} */}
                    {product.special_price && product.mrp && parseFloat(product.special_price) < parseFloat(product.mrp) && (
  <span
    className="badge bg-danger position-absolute top-0 start-0 m-2"
    style={{ zIndex: 50 }}
  >
    {`${Math.round(((parseFloat(product.mrp) - parseFloat(product.special_price)) / parseFloat(product.mrp)) * 100)}%`}
  </span>
)}


                    <img
                      src={getImageUrl(product)}
                      className="card-img-top"
                      alt={product.product_name}
                      onClick={() => navigate(`/productDetails/${product.product_id}`)}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'opacity 0.5s ease',
                        opacity: hoveredProduct === product.product_id ? 0 : 1,
                        zIndex: 1
                      }}
                    />

                    <img
                      src={getImageUrl(product)}
                      className="card-img-top"
                      alt={product.product_name}
                      onClick={() => navigate(`/productDetails/${product.product_id}`)}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'opacity 0.5s ease',
                        opacity: hoveredProduct === product.product_id ? 1 : 0,
                        zIndex: 2
                      }}
                    />

                    <div
                      className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3"
                      style={{
                        opacity: hoveredProduct === product.product_id ? 1 : 0,
                        transform: hoveredProduct === product.product_id ? 'translateY(0)' : 'translateY(100%)',
                        transition: 'all 0.3s ease',
                        pointerEvents: hoveredProduct === product.product_id ? 'auto' : 'none',
                        zIndex: 10
                      }}
                    >
                      {product.stock === 0 ? (
                        <button
                          className="btn w-90 fw-bold"
                          disabled
                          style={{
                            backgroundColor: '#6c757d',
                            color: '#fff',
                            borderRadius: '50px',
                            transition: 'all 0.3s ease',
                            padding: '8px 24px',
                            fontSize: '0.95rem',
                            fontWeight: 'bolder',
                            cursor: 'not-allowed',
                          }}
                        >
                          OUT OF STOCK
                        </button>
                      ) : (
                        <button
                          className="btn w-90 fw-bold"
                          onClick={() => handleQuickAdd(product.product_id)}
                          style={{
                            backgroundColor: '#FFFFFF',
                            color: '#124f14',
                            borderRadius: '50px',
                            transition: 'all 0.3s ease',
                            padding: '8px 24px',
                            fontSize: '0.95rem',
                            fontWeight: 'bolder',
                              //  width: "150px",
                          }}
                        >
                          QUICK ADD
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="card-body text-center">
                    <h6 className="card-title text-muted mb-1" style={{ fontSize: "1.1rem", fontWeight: "500" }}>
                      {product.product_name}
                    </h6>
                    <div className="d-flex justify-content-center align-items-center">
                      {product.mrp &&
                        product.special_price &&
                        parseFloat(product.special_price) < parseFloat(product.mrp) && (
                          <span
                            className="text-muted text-decoration-line-through me-2"
                            style={{ fontSize: "12px" }}
                          >
                            ₹{product.mrp}
                          </span>
                        )
                      }
                      <span className="fw-bold" style={{ fontSize: "14px", color: "#7c0046" }}>
                        ₹
                        {product.special_price
                          ? parseFloat(product.special_price) < parseFloat(product.mrp)
                            ? product.special_price 
                            : product.special_price
                          : product.mrp}        
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

  
      <div className="d-md-none">
  <div className="position-relative">
    <div 
      className="d-flex overflow-hidden" 
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {products.map((product, index) => {
        const start = mobilePage * 2;
        const end = start + 2;
        if (index < start || index >= end) return null;

        return (
          <div key={product.product_id} className="flex-shrink-0 me-2" style={{ width: '48%' }}>
            <div className="card border-0 shadow-sm h-100">
              {/* Fixed-height image container */}
              <div 
                className="position-relative overflow-hidden" 
                style={{ height: '260px', backgroundColor: '#f8f9fa' }}
              >
                {/* Sale badge */}
                {product.special_price && product.mrp && parseFloat(product.special_price) < parseFloat(product.mrp) && (
                  <span className="badge bg-danger position-absolute top-0 start-0 m-2">
                    {`-${Math.round(100 - (parseFloat(product.special_price) / parseFloat(product.mrp)) * 100)}%`}
                  </span>
                )}

                {/* Eye icon */}
                <span
                  className="position-absolute top-0 end-0 m-2"
                  style={{ zIndex: 5, padding: '4px', cursor: 'pointer' }}
                  onClick={() => {
    setSelectedProduct(product);
    setShowQuickView(true);
  }}
                >
                  <i className="bi bi-eye fs-5" style={{ color: '#000' }}></i>
                </span>

                {/* Base image (visible by default) */}
                <img
                  src={getImageUrl(product)}
                  alt={product.product_name}
                  className="w-100 h-100"
                  style={{
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    transition: 'opacity 0.5s ease',
                    opacity: hoveredProduct === product.product_id ? 0 : 1,
                    zIndex: 1,
                  }}
                  onClick={() => navigate(`/productDetails/${product.product_id}`)}
                />

                {/* Hover image (same as base — for consistency) */}
                <img
                  src={getImageUrl(product)}
                  alt={product.product_name}
                  className="w-100 h-100"
                  style={{
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    transition: 'opacity 0.5s ease',
                    opacity: hoveredProduct === product.product_id ? 1 : 0,
                    zIndex: 2,
                  }}
                  onClick={() => navigate(`/productDetails/${product.product_id}`)}
                />

                {/* Quick Add / Out of Stock button */}
                <div className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3">
                  {product.stock === 0 ? (
                    <button
                      className="btn fw-semibold w-90"
                      disabled
                      style={{
                        backgroundColor: "#6c757d",
                        color: "#fff",
                        borderRadius: "50px",
                        padding: "8px 24px",
                        fontSize: "0.95rem",
                        cursor: "not-allowed",
                        whiteSpace: "nowrap",
                      }}
                    >
                      OUT OF STOCK
                    </button>
                  ) : (
                    <button
                      className="btn w-90 fw-semibold"
                      onClick={() => handleQuickAdd(product.product_id)}
                      style={{
                        backgroundColor: '#FFFFFF',
                        color: '#124f14',
                        borderRadius: '50px',
                        padding: '8px 24px',
                        fontSize: '0.95rem',
                      }}
                    >
                      QUICK ADD
                    </button>
                  )}
                </div>
              </div>

              {/* Product info */}
              <div className="card-body text-center px-2">
                <h6 className="card-title" style={{ fontSize: '14px', minHeight: '36px' }}>
                  {product.product_name}
                </h6>
                <div className="d-flex justify-content-center align-items-center flex-wrap">
                  {product.mrp &&
                    product.special_price &&
                    parseFloat(product.special_price) < parseFloat(product.mrp) && (
                      <span
                        className="text-muted text-decoration-line-through me-2"
                        style={{ fontSize: "12px" }}
                      >
                        ₹{product.mrp}
                      </span>
                    )}
                  <span className="fw-bold" style={{ fontSize: "14px", color: "#7c0046" }}>
                    ₹
                    {product.special_price
                      ? parseFloat(product.special_price) < parseFloat(product.mrp)
                        ? product.special_price
                        : product.special_price
                      : product.mrp}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>

    {/* Dots indicator */}
    <div className="d-flex justify-content-center mt-2">
      {Array.from({ length: Math.ceil(products.length / 2) }).map((_, idx) => (
        <span
          key={idx}
          className="mx-1 rounded-circle"
          style={{
            width: '10px',
            height: '10px',
            backgroundColor: mobilePage === idx ? '#000' : '#ccc',
            display: 'inline-block',
            cursor: 'pointer'
          }}
          onClick={() => setMobilePage(idx)}
        ></span>
      ))}
    </div>

    {/* Navigation arrows */}
    <div className="position-absolute top-50 start-0 translate-middle-y">
      <button className="btn btn-light btn-sm" onClick={handlePrev}>❮</button>
    </div>
    <div className="position-absolute top-50 end-0 translate-middle-y">
      <button className="btn btn-light btn-sm" onClick={handleNext}>❯</button>
    </div>
  </div>
</div>

      {showLoginModal && (
        <LoginModal
          show={showLoginModal}
          handleClose={() => setShowLoginModal(false)}
          handleLoginSuccess={(userData) => {
            localStorage.setItem("auth_token", userData.token);
            setShowLoginModal(false);
          }}
        />
      )}
      <ProductQuickViewModal show={showQuickView} onHide={() => setShowQuickView(false)} product={selectedProduct}  productId={selectedProduct?.product_id || selectedProduct?.id}  />
    </div>
  );
};

export default TodaysPick;